import { createTheme, ThemeOptions } from "@mui/material/styles";

export const themeOptions: ThemeOptions = {
  palette: {
    mode: "light",
    primary: {
      main: "#2b7cb4",
    },
    secondary: {
      main: "#130d17",
    },
    error: {
      main: "#e5321e",
    },
    background: {
      paper: "#e3dabb",
    },
    success: {
      main: "#4e6e58",
    },
  },
  typography: {
    fontFamily: "Oswald",
    h1: {
      fontSize: "1.5rem",
      "@media (min-width:600px)": {
        fontSize: "2rem",
      },
      // [lightTheme.breakpoints.up("md")]: {
      //   fontSize: "3rem",
      // },
    },

    h4: {
      fontSize: "1rem",
      "@media (max-width: 600px)": {
        fontSize: "1rem",
      },
    },
  },
};

var lightTheme = createTheme(themeOptions);

export default lightTheme;
